var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#575757"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dine In Mid Fid UI"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -153,
    y: -791,
    width: 390,
    height: 844,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004054"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004086",
    filter: "url(#filter0_d_264_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 70,
    transform: "translate(-153 -16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 54,
    transform: "translate(-23 -16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6664",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09196 17.5524C6.09196 17.5524 6.72293 13.889 4.92601 11.8698C4.82827 11.7594 4.8335 11.5968 4.93299 11.4881C5.55262 10.8124 7.12612 11.5072 8.70748 14.3977C9.12115 15.1516 9.98339 15.1124 10.7322 14.6863C12.1573 13.8759 14.0494 11.7655 15.355 11.435C17.0733 11.0003 17.6668 12.0437 17.336 12.3733L9.84027 19.8411L6.09196 17.5524V17.5524Z",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6665",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67664 20.9999L9.83909 19.8407L6.09078 17.552L2.94727 20.9999H8.67664Z",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6666",
    d: "M21 10.5651H1",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6667",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2316 10.5649C19.2395 10.4197 19.2535 10.2771 19.2535 10.1302C19.2535 5.56755 15.5418 1.86929 10.9627 1.86929C6.3844 1.86929 2.67188 5.56755 2.67188 10.1302C2.67188 10.2771 2.68671 10.4197 2.69457 10.5649H19.2316V10.5649Z",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6668",
    d: "M10.962 4.04349C8.18761 4.04349 5.83826 5.85305 5.03711 8.35218",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6669",
    d: "M10.5273 1.86956V1",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_264_141",
    x: -184,
    y: -44,
    width: 444,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_264_141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -153,
    y: -791,
    width: 390,
    height: 844,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderOutlined);
export default __webpack_public_path__ + "static/media/order-outlined.90b909b97e6fca9584f8636eca6c925b.svg";
export { ForwardRef as ReactComponent };